var render, staticRenderFns
import script from "./Global_qingzhu.vue?vue&type=script&lang=js&"
export * from "./Global_qingzhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Global_qingzhu.vue"
export default component.exports